import { FaShareAlt } from "react-icons/fa";
import useCustomNavigate from "../../../../hooks/useCustomNavigate";
import { useParams } from "react-router-dom";

const images = [
  "https://img.staticmb.com/mbphoto/property/cropped_images/2024/Sep/18/Photo_h0_w320/74418401_6_20240918092910_0_320.jpg",
  "https://img.staticmb.com/mbphoto/property/cropped_images/2024/Aug/18/Photo_h0_w320/74418401_2_20240316202419_0_320.jpg",
  "https://img.staticmb.com/mbphoto/property/cropped_images/2024/Sep/19/Photo_h0_w320/74418401_13_20240918123404_0_320.jpg",
  "https://img.staticmb.com/mbphoto/property/cropped_images/2024/Sep/18/Photo_h0_w320/74418401_2_20240918092713_0_320.jpg",
  "https://img.staticmb.com/mbphoto/property/cropped_images/2024/Sep/18/Photo_h0_w320/74418401_2_20240918092713_0_320.jpg",
  "https://img.staticmb.com/mbphoto/property/cropped_images/2024/Sep/19/Photo_h0_w320/74418401_14_20240918122935_0_320.jpg",
  "https://img.staticmb.com/mbphoto/property/cropped_images/2024/Sep/18/Photo_h0_w320/74418401_2_20240918092713_0_320.jpg",
  "https://img.staticmb.com/mbphoto/property/cropped_images/2024/Sep/18/Photo_h0_w320/74418401_2_20240918092713_0_320.jpg",
  "https://img.staticmb.com/mbphoto/property/cropped_images/2024/Sep/18/Photo_h0_w320/74418401_2_20240918092713_0_320.jpg",
  "https://img.staticmb.com/mbphoto/property/cropped_images/2024/Sep/19/Photo_h0_w320/74418401_13_20240918123404_0_320.jpg"
];

const FlatListing = () => {
  const {goTo} = useCustomNavigate()
  const {propertyId} = useParams()
  return (
    <div className="p-4">
    <div className="columns-4 gap-4 space-y-4">
      {images.map((src, index) => (
        <div 
        key={index} 
        className="relative break-inside-avoid cursor-pointer"
        onClick={()=>{goTo(`/propertydetail/${propertyId}/imageswithdetail`)}}
        >
          <img
            src={src}
            alt={`View ${index + 1}`}
            className="w-full object-cover"
          />
          <span className="absolute top-2 left-2 bg-white text-xs font-semibold px-2 py-1 rounded-md shadow">
            VIEW {index + 1}
          </span>
        </div>
      ))}
    </div>
  </div>
  );
};

export default FlatListing;
